export enum BankAccountOwnership {
    Supplier = 'supplier',
    External = 'external',
}
